import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import Profile from "../../../../src/collections/blog/2022/2022-02-25-layer5-collab-with-openforce/thumbnail.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  Profile,
  React
};